import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgs = async () => {
  const url = 'v1/orgs'
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrgs
